export default "__VITE_ASSET__UYQSrGD8__"